export default __webpack_public_path__ + "images/HSA.bd9a0770fa0d5a64090b5e52025da4e3.svg";